import { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Frame,
  TopBar,
  Navigation,
  Avatar,
  FooterHelp,
  Text,
} from "@shopify/polaris";
import Cookies from "js-cookie";
import { AppContext } from "../context/appContext";
import Logo from "./logo";
import Svgmerge from "../images/svgmerge.svg";
import {
  HomeIcon,
  QuestionCircleIcon,
  OrderRepeatIcon,
  StoreFilledIcon,
  OrdersStatusIcon,
  ExitIcon,
  HomeFilledIcon,
  StoreIcon,
  OrderFulfilledIcon,
  PointOfSaleIcon,
  StarIcon,
} from "@shopify/polaris-icons";
import { BsCupFill } from "react-icons/bs";
import { RiCouponFill, RiCouponLine, RiHome2Line, RiHomeSmile2Line } from "react-icons/ri";

const Header = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openMenu, setOpenMenu } = useContext(AppContext);
  console.log("openMenu", openMenu);
  const [userMenuActive, setUserMenuActive] = useState(false);
  // const userEmail = localStorage.getItem("userEmail");
  // const userData = localStorage.getItem("userData");
  // console.log("userData2",userData)
  const userData = localStorage.getItem("userData");
  const parsedUserData = JSON.parse(userData);

  console.log(parsedUserData.name);
  const toggleUserMenu = () => setUserMenuActive((prev) => !prev);
  const LogOutHandler = () => {
    Cookies.remove("token");
    window.location.reload();
  };
  const logoMarkup = {
    topBarSource: Svgmerge,
    contextualSaveBarSource: Svgmerge,
    url: "/",
    width: 120,
  };

  const userMenuMarkup = (
    <TopBar.UserMenu
      open={userMenuActive}
      onToggle={toggleUserMenu}
      actions={[
        {
          items: [
            {
              content: parsedUserData.email,
              disabled: true,
            },
            {
              content: "Logout",
              icon: ExitIcon,
              onAction: LogOutHandler,
            },
          ],
        },
      ]}
      name={parsedUserData.name}
      detail="Admin Panel"
      avatar={
        <Avatar
          customer
          size="medium"
          source={<Logo color1="#000" color2="#0C4A6E" />}
        />
      }
    />
  );

  const topBarMarkup = (
    <TopBar
      logo={logoMarkup}
      showNavigationToggle
      onNavigationToggle={() => setOpenMenu(!openMenu)}
      userMenu={userMenuMarkup}
    />
  );

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            label: "Dashboard",
            icon: location.pathname === "/" ? HomeIcon : HomeFilledIcon,
            selected: location.pathname === "/",
            onClick: () => navigate("/"),
          },
          {
            label: "Inquiries",
            icon:
              location.pathname === "/inquiries"
                ? QuestionCircleIcon
                : QuestionCircleIcon,
            selected: location.pathname === "/inquiries",
            onClick: () => navigate("/inquiries"),
          },
          {
            label: "Reorder",
            icon:
              location.pathname === "/reorder"
                ? OrderRepeatIcon
                : OrderRepeatIcon,
            selected: location.pathname === "/reorder",
            onClick: () => navigate("/reorder"),
          },
          {
            label: "Sellers",
            icon:
              location.pathname === "/sellers" ? StoreFilledIcon : StoreIcon,
            selected: location.pathname === "/sellers",
            onClick: () => navigate("/sellers"),
          },
          {
            label: "Cancel Order",
            icon:
              location.pathname === "/cancel-order"
                ? OrdersStatusIcon
                : OrdersStatusIcon,
            selected: location.pathname === "/cancel-order",
            onClick: () => navigate("/cancel-order"),
          },
          {
            label: "Order Update",
            icon:
              location.pathname === "/order-update"
                ? OrderFulfilledIcon
                : OrderFulfilledIcon,
            selected: location.pathname === "/order-update",
            onClick: () => navigate("/order-update"),
          },
          {
            label: "Birthday Sale",
            icon:
              location.pathname === "/birthday-sale"
                ? PointOfSaleIcon
                : PointOfSaleIcon,
            selected: location.pathname === "/birthday-sale",
            onClick: () => navigate("/birthday-sale"),
          },
          {
            label: "Winners",
            icon: location.pathname === "/winners" ? StarIcon : StarIcon,
            selected: location.pathname === "/winners",
            onClick: () => navigate("/winners"),
          },
          {
            label: "Coupon Code",
            icon:
              location.pathname === "/coupon-code"
                ? RiCouponFill
                : RiCouponLine,
            selected: location.pathname === "/coupon-code",
            onClick: () => navigate("/coupon-code"),
          },
           {
            label: "Coupon Card",
            icon:
              location.pathname === "/couponcard"
                ? RiCouponFill
                : RiCouponLine,
            selected: location.pathname === "/couponcard",
            onClick: () => navigate("/couponcard"),
          },
           {
            label: "Expert Workshop",
            icon:
              location.pathname === "/expert-workshop"
                ? RiHomeSmile2Line
                : RiHome2Line,
            selected: location.pathname === "/expert-workshop",
            onClick: () => navigate("/expert-workshop"),
          },
        ]}
      />
    </Navigation>
  );

  // return (
  //   <Frame
  //     logo={logoMarkup}
  //     topBar={topBarMarkup}
  //     navigation={navigationMarkup}
  //     showMobileNavigation={openMenu}
  //     onNavigationDismiss={() => setOpenMenu(false)}
  //   >
  //     {children}
  //   </Frame>
  // );

  return (
    <Frame
      logo={logoMarkup}
      topBar={topBarMarkup}
      navigation={navigationMarkup}
      showMobileNavigation={openMenu}
      onNavigationDismiss={() => setOpenMenu(false)}
      globalRibbon={
        <FooterHelp>
          <Text fontWeight="bold">
            @ {new Date().getFullYear()} Iplanet | Admin
          </Text>
        </FooterHelp>
      }
    >
      {children}
    </Frame>
  );
};

export default Header;
